import constants from 'constants/index'

const chipStatusColor = (status, classes) => {
  switch (status) {
    case constants.companySuppliers.INDICATED_STATUS:
      return classes.indicated
    case constants.companySuppliers.APPROVED_STATUS:
      return classes.approved
    case constants.companySuppliers.REFUSED_STATUS:
      return classes.refused
    default:
      return classes.inactive
  }
}

export default chipStatusColor
